var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_66491",
    "data-name": "Group 66491",
    transform: "translate(-1845.014 -466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_76332",
    "data-name": "Group 76332"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_79",
    "data-name": "Ellipse 79",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "translate(1845.014 466)",
    fill: "#ba8a8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-navigate-next",
    "data-name": "Icon material-navigate-next",
    d: "M14.268,9l-1.383,1.383,4.491,4.5-4.491,4.5,1.383,1.383,5.883-5.883Z",
    transform: "translate(1841.59 463.754)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.66a088d543d207f2fb8e89e2522c219b.svg";
export { ForwardRef as ReactComponent };